import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { Router } from '@angular/router';
import { finalize, share, tap } from 'rxjs/operators';
import { ExternalLibraryService } from 'src/app/shared/components/util';

@Injectable()
export class UserService {

  public rootUrl = '';
  //readonly rootUrl = 'https://rwtpl.com/online-exam/admin/';

  private cache ={};
  private cachedObservable: Observable<any>;

  private pendingHTTPRequests$ = new Subject<void>();
  public $categoryData =  new Subject();
  public selectedPackage = {};
  public element: Element;
  customerId = '';
  apiUrl='';
  baseUrl='';
  
  public $blogsData =  new Subject();

  constructor( private http: HttpClient,private router: Router,private config: AppConfig,
    private razorpayService: ExternalLibraryService) {
    this.apiUrl = this.config.getConfig('API_URL');
    this.rootUrl = this.config.getConfig('ROOT_URL');
    this.baseUrl = this.config.getConfig('BASEURL');
    this.customerId = this.config.getConfig('CUSTOMER_ID');
   }

   cacheAPI(url): Observable<any> {
    let observable: Observable<any>;
    if (this.cache && this.cache[url]) {
      observable = of(this.cache[url]);
    } else {
      this.cachedObservable = this.http.get<any>(url)
        .pipe(
          tap(res => this.cache[url] = res),
          share(),
          finalize(() => this.cachedObservable = null)
        );
      observable = this.cachedObservable;
    }
    return observable;
  }

   setCustomFieldsData() {
    this.apiUrl = this.config.getConfig('API_URL');
    this.apiUrl = this.config.getConfig('ROOT_URL');
    this.customerId = this.config.getConfig('CUSTOMER_ID');
   }

   loadScriptSync (src) {
    var s = document.createElement('script');
    s.src = src;
    s.type = "text/javascript";
    s.async = false;                                 // <-- this is important
    document.getElementsByTagName('head')[0].appendChild(s);
}


   // Cancel Pending HTTP calls
   public cancelPendingRequests() {
    this.pendingHTTPRequests$.next();
  }

  public onCancelPendingRequests() {
    return this.pendingHTTPRequests$.asObservable();
  }

  public setCategoyData(data) {
    this.$categoryData.next(data);
  }

  public getCategoryData() {
    return this.$categoryData.asObservable();
  }

  public setBlogsData(data) {
    this.$blogsData.next(data);
  }

  public getBlogsData() {
    return this.$blogsData.asObservable();
  }

  userRegistration(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/social-registration', data);
  }

  saveRegistration(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    // this.loadScriptSync('https://checkout.razorpay.com/v1/checkout.js');
    return this.http.post(this.apiUrl + 'api/user-registration', data);
  }

  validateLogin(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/user-login', data);
  }

  savePostData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/user-post', data);
  }

  savePostDataBeforeLogin(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/user-doubts', data);
  }

  getNotesData(id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-notes/'+id);
    return this.cacheAPI(this.apiUrl + 'api/get-notes/'+id);
  }

  getBlogs(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/blogs/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/blogs/'+this.customerId);
  }

  getCurrentAffairs(data){
    return this.http.post('https://www.hranker.com/admin/api/current-affairs-by-date', data);
  }

  getCurrentAffairsDetails(current_affair_id){
    //return this.http.get(this.apiUrl + 'api/blogs/'+blog_id);
    return this.cacheAPI('https://www.hranker.com/admin/api/current-affairs-by-id/'+current_affair_id);
  }

  getDailySchedule(date){
    return this.cacheAPI(this.apiUrl + 'api/get-scheduled-pdf/'+date);
  }

  updateUserData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/update-user', data);
  }

  userData(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/user-data/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/user-data/'+user_id+'/'+this.customerId);
  }

  changePassword(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/update-password', data);
  }

  getCAData(type){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/current-affairs/'+type);
    return this.cacheAPI(this.apiUrl + 'api/current-affairs/'+type);
  }

  blogDetails(blog_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/blogs/'+this.customerId+'/'+blog_id);
    return this.cacheAPI(this.apiUrl + 'api/blogs/'+this.customerId+'/'+blog_id);
  }

  getPageData(slug){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/page/'+slug+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/page/'+slug+'/'+this.customerId);
  }

  homeData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/home-data/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/home-data/'+this.customerId);
  }

  getDynamicScreenInitData(routeUrl) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/{{new-api}}'+routeUrl);
    return this.cacheAPI(this.apiUrl + 'api/{{new-api}}'+routeUrl);
  }

  getStudyData(cat){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/study-data/'+cat);
    return this.cacheAPI(this.apiUrl + 'api/study-data/'+cat);
  }

  getStudyDetailData(cat){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/study-detail/'+cat);
    return this.cacheAPI(this.apiUrl + 'api/study-detail/'+cat);
  }

  getUserSeries(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/user-series/'+user_id);
  //  return this.cacheAPI(this.apiUrl + 'api/user-series/'+user_id);
  }

  freeTestSeries(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/free-test-series/'+user_id);
  //  return this.cacheAPI(this.apiUrl + 'api/free-test-series/'+user_id);
  }


  searchData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/search/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/search/'+this.customerId);
  }

  getPackageSeries(package_id, user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/package-series/'+package_id+'/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/package-series/'+package_id+'/'+user_id);
  }

  getForum(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/forum/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/forum/'+this.customerId);
  }

  forumDetails(forum_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/forum/'+this.customerId+'/'+forum_id);
    return this.cacheAPI(this.apiUrl + 'api/forum/'+this.customerId+'/'+forum_id);
  }

  getOffers(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/offers/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/offers/'+this.customerId);
  }

  getSavedQuestionData(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/saved-question/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/saved-question/'+user_id);
  }

  getReportQuestionData(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/report-question/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/report-question/'+user_id);
  }

  forgotPassword(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/forgot-password', data);
  }

  getCareerData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/careers/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/careers/'+this.customerId);
  }

  applyCareer(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/job-apply', data);
  }

  contactUs(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/contact-us', data);
  }


  getUser(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-user/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/get-user/'+user_id);
  }

  saveComment(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/add-comment', data);
  }

  saveCommentBeforeLogin(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/add-comment', data);
  }

  allComments(blog_id, test){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-comments/'+blog_id);
    return this.cacheAPI(this.apiUrl + 'api/get-comments/'+blog_id);
  }

  getMorePackageSeries(package_id, user_id, limit, offset){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/package-series-load/'+package_id+'/'+user_id+'/'+limit+'/'+offset);
    return this.cacheAPI(this.apiUrl + 'api/package-series-load/'+package_id+'/'+user_id+'/'+limit+'/'+offset);
  }

  getTestSeriesTabsCountBeforeLogin(package_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
 //   return this.http.get(this.apiUrl + 'api/get-tab-package-series-count/'+package_id);
    return this.cacheAPI(this.apiUrl + 'api/get-tab-package-series-count/'+package_id);
  }

  getTestSeriesTabsCount(package_id, userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/get-tab-package-series-count-v1/'+package_id+'/'+userId);
    return this.cacheAPI(this.apiUrl + 'api/get-tab-package-series-count-v1/'+package_id+'/'+userId);
  }

  getTestSeriesTabData(package_id, parentIndex, childIndex, subChildIndex, customRowIndex,  user_id, start, end) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-tab-package-series/'+package_id+'/'+ parentIndex+'/'+ childIndex+'/'+ subChildIndex+'/'+customRowIndex+'/'+user_id+'/'+start+'/'+end+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/get-tab-package-series/'+package_id+'/'+ parentIndex+'/'+ childIndex+'/'+ subChildIndex+'/'+customRowIndex+'/'+user_id+'/'+start+'/'+end+'/'+this.customerId);
  }

  //test
  addLike(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/add-like', data);
  }

  getPageInitData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/banner/'+this.customerId+'/' + data);
    return this.cacheAPI(this.apiUrl + 'api/banner/'+this.customerId+'/' + data);
  }
  getPageInitDataExam(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/banner/'+this.customerId+'/' + data);
   return this.http.get(this.apiUrl + 'api/banner/' + data);
  }
  getUpcomingExamsData(cat_id, subcat_id, startDate, endDate, top, limit) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/getUpcomingExam/'+cat_id+'/'+subcat_id+'/'+startDate+'/'+endDate+'/'+top+'/'+limit+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/getUpcomingExam/'+cat_id+'/'+subcat_id+'/'+startDate+'/'+endDate+'/'+top+'/'+limit+'/'+this.customerId);
  }

  getDoubts(doubt_id, type, url_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/get-doubts/'+doubt_id+'/'+type+'/'+url_id);
  }
  getSubDoubts(doubt_id, type, url_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/get-doubts/'+doubt_id+'/'+type+'/'+url_id);
  }

  getStates() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.cacheAPI(this.apiUrl + 'api/states');
  }

  getMobileNoExists(mobNo) {
    return this.http.get(this.apiUrl + 'api/checkMobileExist/'+mobNo);
  }

  userDataByMobile(mobNo){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  var data={
    "mobile": mobNo,
    "logged_in_via":"web"
  }
    return this.http.post(this.apiUrl + 'api/user-mobile-login', data);
  }

  scholarshipFormRegistration(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/student-scholarship-registration', data);
  }

  admissionFormRegistration(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id'] = this.customerId;
    return this.http.post(this.apiUrl + 'api/customer-student-registration', data);
  }


}
